/* __next_internal_client_entry_do_not_use__ localAESStorage,sessionAESStorage auto */import { isObject, isUndefined } from "__barrel_optimize__?names=isObject,isUndefined!=!lodash-es";
import aesCrypto from "./crypto";
import { DEFAULT_EXPIRE_TIME, VARIABLE_GARD_TOKEN } from "./config";
import { AESStorageProps } from "./interface";
import { tryParseJson } from "..";
import { inServer } from "@/util/next";
class AESStorage {
  /**
  * 存储到 storage
  * @param key
  * @param value
  * @param expire 过期时间 单位 s，不传则不会过期
  */
  setItem(key, value, expire) {
    const data = {
      value,
      time: Date.now(),
      expire: isUndefined(expire) ? undefined : Date.now() + 1000 * expire
    };
    this.storage.setItem(key, aesCrypto.encrypt(JSON.stringify(data)));
  }
  getItem(key) {
    const initial = this.storage.getItem(key);
    if (!initial) return null;
    const result = tryParseJson(aesCrypto.decrypt(initial));
    const now = Date.now();
    if (result.expire && now >= result.expire) {
      //过期销毁
      this.removeItem(key);
      return null;
      //不过期回值
    } else {
      return result.value;
    }
  }
  /**
  * 单一变量合集
  * @description 一般用于设置简单的变量，比如点赞、转发等需要进行刷数处理，此时不希望一个变量
  * 占用一个 key，就可以采取这个方法，参考 src/components/build/ConsFormHeader/index.tsx 分享按钮
  * @param key
  */
  setFlag(key) {
    let expire = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_EXPIRE_TIME;
    const data = {
      value: key,
      time: Date.now(),
      expire: Date.now() + 1000 * expire
    };
    const initial = this.storage.getItem(VARIABLE_GARD_TOKEN);
    let dataSet = initial ? tryParseJson(aesCrypto.decrypt(initial)) : {};
    if (isObject(dataSet)) {
      dataSet[key] = data;
    } else {
      dataSet = {
        [key]: data
      };
    }
    this.storage.setItem(VARIABLE_GARD_TOKEN, aesCrypto.encrypt(JSON.stringify(dataSet)));
  }
  /**
  * 获取 flag 是否存在
  * @param key
  * @returns
  */
  getFlag(key) {
    const initial = this.storage.getItem(VARIABLE_GARD_TOKEN);
    if (!initial) return true;
    const dataSet = tryParseJson(aesCrypto.decrypt(initial));
    if (!dataSet) return true;
    const data = dataSet[key];
    if (!data) return true;
    return Date.now() >= data.expire;
  }
  removeItem(key) {
    this.storage.removeItem(key);
  }
  clear() {
    this.storage.clear();
  }
  constructor(options) {
    const {
      type
    } = options;
    this.storage = window[type];
  }
}
let local = null;
export const localAESStorage = (() => {
  if (inServer()) {
    // 实际上也没机会执行
    return {
      getItem() {},
      setItem() {},
      removeItem() {},
      getFlag() {},
      setFlag() {},
      clear() {}
    };
  }
  if (!local) local = new AESStorage({
    type: AESStorageProps.Type.local
  });
  return local;
})();
let session = null;
export const sessionAESStorage = (() => {
  if (inServer()) {
    return {
      getItem() {},
      setItem() {},
      removeItem() {},
      getFlag() {},
      setFlag() {},
      clear() {}
    };
  }
  if (!session) session = new AESStorage({
    type: AESStorageProps.Type.session
  });
  return session;
})();